
const SIZE = 2;
const STROKE_WIDTH = 0.5;

export function Plus() {
  return (
    <g>
      <line x1={-SIZE} y1={0} x2={SIZE} y2={0} stroke="black" strokeWidth={STROKE_WIDTH} />
      <line x1={0} y1={-SIZE} x2={0} y2={SIZE} stroke="black" strokeWidth={STROKE_WIDTH} />
    </g>
  );
}
